import { Autorenew } from '@material-ui/icons'
import React, { useState } from 'react'
import {
  sanitizeFetchType,
  useMutation,
  useNotify,
  useRecordContext,
  useRefresh,
  useShowContext,
} from 'react-admin'
import { EngineDto } from '../../../../core/dto/device/engine/engine.dto'
import Button from '../../../common/customized-mui-components/Button'
import { EngineUploadPackDialog } from '../EngineDialogs'
import { useHasAuthority } from '../../../hooks/useHasAuthority'
import { Authority } from '../../../../core/auth/Authority'
import { ResourceName } from '../../../../core/ResourceName'

export const EngineUploadPackButton = ({ ...props }) => {
  const { asRecurringJob, ...rest } = props
  const notify = useNotify()
  const hasAuthority = useHasAuthority()
  const { loading } = useShowContext()
  const [uploadDialogOpen, setUploadDialogOpen] = useState(false)
  const [packId, setPackId] = useState(0)
  const engine = useRecordContext<EngineDto>()
  const [mutate, { loading: mutationLoading }] = useMutation()
  const refresh = useRefresh()

  const onClick = async () => {
    setUploadDialogOpen(true)
  }

  const handleUploadPack = async (
    recurringJobName?: string,
    cronExpression?: string,
  ) => {
    await mutate(
      {
        type: sanitizeFetchType('uploadPack'),
        resource: ResourceName.ENGINES,
        payload: {
          engineId: engine?.id,
          mediaPackId: packId,
          recurringJobName,
          cronExpression,
        },
      },
      {
        returnPromise: true,
        onFailure: (err) => notify(err?.message, 'error'),
      },
    )
    refresh()
  }

  return (
    <>
      <EngineUploadPackDialog
        open={uploadDialogOpen}
        close={() => setUploadDialogOpen(false)}
        packId={packId}
        setPackId={setPackId}
        handleUploadPack={handleUploadPack}
        asRecurringJob={asRecurringJob}
      />
      <Button
        variant="contained"
        color="primary"
        label={!asRecurringJob ? 'resources.engines.actions.upload-pack' : ''}
        useSmallVersionBreakpoint={false}
        disabled={
          !hasAuthority(Authority.ENGINES_UPLOAD_PACK_BUTTON) ||
          loading ||
          mutationLoading
        }
        onClick={onClick}
        size="small"
        {...rest}
      >
        {asRecurringJob ? <Autorenew /> : undefined}
      </Button>
    </>
  )
}
